import { render, staticRenderFns } from "./OverviewView.vue?vue&type=template&id=538bc8dc&scoped=true"
import script from "./OverviewView.vue?vue&type=script&lang=js"
export * from "./OverviewView.vue?vue&type=script&lang=js"
import style0 from "./OverviewView.vue?vue&type=style&index=0&id=538bc8dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "538bc8dc",
  null
  
)

export default component.exports